import React, {CSSProperties, useCallback, useEffect, useId, useRef, useState} from "react";
import {getTrackBackground, Range as ReactRange} from "react-range";
import {IRenderTrackParams} from "react-range/lib/types";
import classNames from "classnames";

import {getThemeVariable} from "@pg-design/styles-strings";
import {Text} from "@pg-design/text-module";
import {useIsMounted} from "@pg-mono/hooks";

import {IRange} from "../types/IRange";
import {RangeType} from "../types/RangeType";
import {UnitsType} from "../types/UnitsType";
import {changeValue} from "../utils/change_value";
import {getInitialValue} from "../utils/get_initial_values";
import {getLabelFromExtremum} from "../utils/get_label_from_extremum";

import * as cns from "./SlimRange.module.css";

interface IProps {
    name: string;
    value: IRange<RangeType>;
    error?: string[];
    onChange: (fieldName: string, value: IRange<RangeType>) => void;
    step: number;
    min: number;
    max: number;
    unitType?: UnitsType;
    useDynamicChange?: boolean;
    hideLabels?: boolean;
    className?: string;
    disabled?: boolean;
}

export const SlimRange = (props: IProps) => {
    const {value, min, max, step, disabled, unitType = UnitsType.NUMBERS, useDynamicChange, className} = props;

    const rangeRef = useRef<ReactRange>(null);
    const [localValues, setLocalValues] = useState(getInitialValue(value, min));

    const thumbKey = useId();

    useEffect(() => {
        const newValue = changeValue(value, min, max);
        if (newValue && useDynamicChange) {
            setLocalValues(newValue);
        }
    }, [value]);

    const renderTrackCallback = useCallback(
        ({props: trackProps, children}: IRenderTrackParams) => {
            return (
                <div onMouseDown={trackProps.onMouseDown} onTouchStart={trackProps.onTouchStart} className={cns.slimRangeTrack}>
                    <div
                        ref={trackProps.ref}
                        className={cns.slimRangeTrackContent}
                        style={
                            {
                                "--track-bg": getTrackBackground({
                                    values: localValues,
                                    colors: getTrackBgColors(props.value),
                                    min,
                                    max
                                })
                            } as CSSProperties
                        }
                    >
                        {children}
                    </div>
                </div>
            );
        },
        [localValues, min, max, value]
    );

    const isMounted = useIsMounted();

    if (!isMounted) {
        return null;
    }

    return (
        <div className={classNames(className, cns.slimRange)}>
            <ReactRange
                disabled={disabled}
                ref={rangeRef}
                onFinalChange={(newValues) => {
                    /**
                     * TODO Like in Range, that makes it actually a single value range, like a "SlimMaxRange"
                     *  We should change the name or implementation
                     */
                    props.onChange(props.name, {
                        lower: 0,
                        upper: newValues[0]
                    });
                }}
                onChange={(value) => {
                    setLocalValues(value);
                    if (useDynamicChange) {
                        props.onChange(props.name, {lower: 0, upper: value[0]});
                    }
                }}
                values={localValues}
                step={step}
                min={min}
                max={max}
                renderTrack={renderTrackCallback}
                renderThumb={({props}) => (
                    <div {...props} style={props.style} key={thumbKey} className={cns.slimRangeThumbWrap}>
                        <div className={cns.slimRangeThumb}></div>
                    </div>
                )}
            />
            {!props.hideLabels && (
                <div className={cns.slimRangeThumbLabel}>
                    <Text variant="info_txt_2" align="left" className={cns.slimRangeThumbLabelText}>
                        {`Od ${getLabelFromExtremum(unitType, min)}`}
                    </Text>
                    <Text variant="info_txt_2" align="right" className={cns.slimRangeThumbLabelText}>
                        {`Do ${getLabelFromExtremum(unitType, max)}`}
                    </Text>
                </div>
            )}
        </div>
    );
};

// Utils
function getTrackBgColors(value: IProps["value"]) {
    if ("lower" in value && "upper" in value) {
        return [getThemeVariable("colors.gray.300"), getThemeVariable("colors.highlight"), getThemeVariable("colors.gray.300")];
    }

    return [getThemeVariable("colors.highlight"), getThemeVariable("colors.gray.300")];
}
import React, {CSSProperties, useCallback, useEffect, useId, useRef, useState} from "react";
import {getTrackBackground, Range as ReactRange} from "react-range";
import {IRenderTrackParams} from "react-range/lib/types";
import classNames from "classnames";

import {getThemeVariable} from "@pg-design/styles-strings";
import {Text} from "@pg-design/text-module";
import {useIsMounted} from "@pg-mono/hooks";

import {IRange} from "../types/IRange";
import {RangeType} from "../types/RangeType";
import {UnitsType} from "../types/UnitsType";
import {changeValue} from "../utils/change_value";
import {getInitialValue} from "../utils/get_initial_values";
import {getLabelFromExtremum} from "../utils/get_label_from_extremum";

import * as cns from "./SlimRange.module.css";

interface IProps {
    name: string;
    value: IRange<RangeType>;
    error?: string[];
    onChange: (fieldName: string, value: IRange<RangeType>) => void;
    step: number;
    min: number;
    max: number;
    unitType?: UnitsType;
    useDynamicChange?: boolean;
    hideLabels?: boolean;
    className?: string;
    disabled?: boolean;
}

export const SlimRange = (props: IProps) => {
    const {value, min, max, step, disabled, unitType = UnitsType.NUMBERS, useDynamicChange, className} = props;

    const rangeRef = useRef<ReactRange>(null);
    const [localValues, setLocalValues] = useState(getInitialValue(value, min));

    const thumbKey = useId();

    useEffect(() => {
        const newValue = changeValue(value, min, max);
        if (newValue && useDynamicChange) {
            setLocalValues(newValue);
        }
    }, [value]);

    const renderTrackCallback = useCallback(
        ({props: trackProps, children}: IRenderTrackParams) => {
            return (
                <div onMouseDown={trackProps.onMouseDown} onTouchStart={trackProps.onTouchStart} className={cns.slimRangeTrack}>
                    <div
                        ref={trackProps.ref}
                        className={cns.slimRangeTrackContent}
                        style={
                            {
                                "--track-bg": getTrackBackground({
                                    values: localValues,
                                    colors: getTrackBgColors(props.value),
                                    min,
                                    max
                                })
                            } as CSSProperties
                        }
                    >
                        {children}
                    </div>
                </div>
            );
        },
        [localValues, min, max, value]
    );

    const isMounted = useIsMounted();

    if (!isMounted) {
        return null;
    }

    return (
        <div className={classNames(className, cns.slimRange)}>
            <ReactRange
                disabled={disabled}
                ref={rangeRef}
                onFinalChange={(newValues) => {
                    /**
                     * TODO Like in Range, that makes it actually a single value range, like a "SlimMaxRange"
                     *  We should change the name or implementation
                     */
                    props.onChange(props.name, {
                        lower: 0,
                        upper: newValues[0]
                    });
                }}
                onChange={(value) => {
                    setLocalValues(value);
                    if (useDynamicChange) {
                        props.onChange(props.name, {lower: 0, upper: value[0]});
                    }
                }}
                values={localValues}
                step={step}
                min={min}
                max={max}
                renderTrack={renderTrackCallback}
                renderThumb={({props}) => (
                    <div {...props} style={props.style} key={thumbKey} className={cns.slimRangeThumbWrap}>
                        <div className={cns.slimRangeThumb}></div>
                    </div>
                )}
            />
            {!props.hideLabels && (
                <div className={cns.slimRangeThumbLabel}>
                    <Text variant="info_txt_2" align="left" className={cns.slimRangeThumbLabelText}>
                        {`Od ${getLabelFromExtremum(unitType, min)}`}
                    </Text>
                    <Text variant="info_txt_2" align="right" className={cns.slimRangeThumbLabelText}>
                        {`Do ${getLabelFromExtremum(unitType, max)}`}
                    </Text>
                </div>
            )}
        </div>
    );
};

// Utils
function getTrackBgColors(value: IProps["value"]) {
    if ("lower" in value && "upper" in value) {
        return [getThemeVariable("colors.gray.300"), getThemeVariable("colors.highlight"), getThemeVariable("colors.gray.300")];
    }

    return [getThemeVariable("colors.highlight"), getThemeVariable("colors.gray.300")];
}
